import template from './item-templates.html';
import controller from './item-templates.controller';

let itemTemplatesComponent = {
    restrict: 'E',
    bindings: {},
    template,
    controller
};

export default itemTemplatesComponent;
